import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- GET ALL Clients -------------------- */
export const AllClientsThunk = createAsyncThunk(
  "clients/AllClientsThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/customer/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch clients");
    }
  }
);

/* -------------------- GET SINGLE Client -------------------- */
export const GetSingleClientThunk = createAsyncThunk(
  "clients/GetSingleClientThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/customer/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch client details"
      );
    }
  }
);

/* -------------------- ADD Client -------------------- */
export const AddClientThunk = createAsyncThunk(
  "clients/AddClientThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/customer/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add client");
    }
  }
);

/* -------------------- UPDATE Client -------------------- */
export const UpdateClientThunk = createAsyncThunk(
  "clients/UpdateClientThunk",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/customer/update`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update client");
    }
  }
);


/* -------------------- DELETE Client -------------------- */
export const DeleteClientThunk = createAsyncThunk(
  "clients/DeleteClientThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/customer/delete?uuid=${uuid}`);
      return {
        uuid,
        message: response.data?.message || "Client deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to delete client");
    }
  }
);
